module.exports = __webpack_public_path__ + "img/CREDIT_LIMIT_ALERT_70_WEB.png";